import { AnalyticsBrowser } from '@segment/analytics-next';
import { getEnv } from './getEnv';

const env = getEnv();

const getSegmentWriteKey = () => {
  if (env === 'local') return '';
  if (env === 'staging') return 'vuQg7FX49kSQHoHhTQMhw4P9X78SoMXS';
  if (env === 'sandbox') return ''; // TODO: Add sandbox Segment write key
  if (env === 'prod') return 'ARYzRWn2FpoptDNhbXhgmrgnX2mv9pWk';
};

const analytics = AnalyticsBrowser.load({ writeKey: getSegmentWriteKey() });

export const analyticsTrackEvent = (eventName, eventEntity, param = {}) => {
  try {
    const analyticsParams = {
      platform: 'admin-web',
      entity: eventEntity,
    };
    const event = { ...analyticsParams, ...param };
    analytics.track(eventName, event);
  } catch (e) {
    console.error(e);
  }
};

export const segmentMiddleware = (fetchType, resource, params) => {
  if (fetchType === 'UPDATE' && resource === 'User') {
    const data = {
      userId: params.data.id,
      email: params.data.email,
      userName: params.data.username,
      firstName: params.data.first_name,
      lastName: params.data.last_name,
      phone: params.data.phone,
      jobTitle: params.data.job_title,
    };

    if (params.data.updateUserInput?.company_id) {
      data.companyId = params.data.updateUserInput.company_id;
      analyticsTrackEvent('User Added To Company', 'User', data);
    }
  }

  if (fetchType === 'DELETE' && resource === 'User') {
    const data = {
      userId: params.id,
    };
    analyticsTrackEvent('Account Deleted', 'User', data);
  }

  if (fetchType === 'UPDATE' && resource === 'Project') {
    const data = {
      projectId: params.data.id,
      projectName: params.data.name,
      projectAddress: params.data.address,
      projectOwner: params.data.owner,
      projectContact: params.data.contact_details,
      projectClassification: params.data.classification,
      projectStartDate: params.data.start_date,
      projectEndDate: params.data.end_date,
      projectComments: params.data.comments,
    };
    analyticsTrackEvent('Project Info Updated', 'Project', data);
  }
};
